import { ACCOUNT_STATUS } from '../constants'

const CANCELLABLE_ACCOUNT_STATUSES = [ACCOUNT_STATUS.ACTIVE, ACCOUNT_STATUS.PAST_DUE, ACCOUNT_STATUS.PAUSED]

export const isSubscriptionPaused = (status) => status?.toUpperCase() === ACCOUNT_STATUS.PAUSED

export const canCancelSubscription = (status) => {
  const normalizedStatus = status?.toUpperCase()

  return Boolean(
    CANCELLABLE_ACCOUNT_STATUSES.includes(normalizedStatus) || normalizedStatus?.startsWith(ACCOUNT_STATUS.DOWNGRADING)
  )
}
